shadow$provide[498] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, cache:{enumerable:true, get:function() {
  return cache;
}}});
var require$_DOT__SLASH_queue = require("./queue");
var require$_DOT__SLASH_hash = require("./hash");
const cache = function(fetch) {
  const cached = {};
  const push = (0,require$_DOT__SLASH_queue.queue)(100);
  return function(name) {
    const key = name.length > 32 ? "##" + (0,require$_DOT__SLASH_hash.hash)(name).toString(16) : name;
    const expire = push(key);
    if (expire != null) {
      delete cached[expire];
    }
    if (cached[key] == null) {
      cached[key] = fetch(name);
    }
    return cached[key].clone();
  };
};

};